/** Native controls keep their activation and navigation keys while reader shortcuts stay available. */
export function nativeControlKey(target: Element, key: string): boolean {
  return ["Enter", " ", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(key)
    && !!target.closest('button, a[href], summary, [role="button"], [role="radio"], [role="tab"], [role="menuitem"], [role="slider"]');
}
